
import {of as observableOf,  Observable } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ITenants } from '@shared/services/api/legacy/multitenantlogin-service/multitenantlogin-model';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';

@Injectable()
export class MultiTenantLoginsService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.api.baseUrl}${environment.api.prefix}${MultiTenantLoginsService.ENDPOINT}`; }
    private static readonly ENDPOINT = '/multitenantlogins';

    public getTenants(token: string): Observable<SuccessResponse<ITenants> | ErrorResponse> {
        const headers = this.createHttpHeaders(token);
        return this.http
            .get<SuccessResponse<ITenants>>(MultiTenantLoginsService.URL, { headers}).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    private createHttpHeaders(token: string): HttpHeaders {
        const h: { [name: string]: string | string[] } = { };
        if (!!token) {
            h['Authorization'] = 'Bearer ' + token;
        }
        const headers = new HttpHeaders(h);
        return headers;
    }
}
